import cn from "classnames";
import type {AppNavLinkProps} from "./NavLink.types";

type AppLinkStyleProps = Pick<AppNavLinkProps, "size" | "className"> & {isActive: boolean};

export const getClassNames = (props: AppLinkStyleProps) => {
  return cn(
    props.className,
  );
};